<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6">
          Input Kode / No Pelunasan
        </v-card-title>

        <v-container>
          <v-text-field
            v-model="formData.no_pelunasan"
            label="Kode Pelunasan / No Pelunasan"
            outlined
            hide-details
            @keydown.enter="checkNomorNota"
            :disabled="loading"
            :loading="loading"
            autofocus
          ></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "PelunasanModal",
  props: ["openModal"],
  data() {
    return {
      formData: {
        no_pelunasan: ""
      },
      loading: false
    };
  },
  watch: {
    openModal(val) {
      if (val) {
        this.formData.no_pelunasan = "";
      }
    },
    "formData.no_pelunasan"(val) {
      if (val) {
        this.formData.no_pelunasan = val.toUpperCase();
      }
    }
  },
  methods: {
    async checkNomorNota() {
      this.loading = true;

      await axios
        .post(`pelunasan/fetch-pelunasan`, this.formData)
        .then(res => {
          this.loading = false;
          this.$emit("close-modal", res.data);
        })
        .catch(err => {
          const message = err?.response?.data?.message;
          const status = err?.response?.status;

          this.loading = false;
          alert(message || "Gagal memuat data");
        });
    }
  }
};
</script>
